<template>
  <div class="outer">
    <div class="inner">
      <h1>Dashboard</h1>
      <div class="stacks">
        <div class="stack">
          <div class="block news">
            <h2>News</h2>
            <div>Alter, lotus danistas inciviliter visum de castus, varius capio.</div>
          </div>
          <div class="block alerts">
            <h2>Alerts</h2>
            <div>Alter, lotus danistas inciviliter visum de castus, varius capio.</div>
          </div>
          <div class="block feed">
            <h2>Feed</h2>
            <div>Alter, lotus danistas inciviliter visum de castus, varius capio.</div>
          </div>
        </div>
        <div class="stack">
          <div class="block user-kpis">
            <h2>Personal Statistics</h2>
            <div class="statistics" v-if="loadingBrokerStatistics">
              <v-skeleton-loader type="button"/>
              <v-skeleton-loader type="button"/>
              <v-skeleton-loader type="button"/>
              <v-skeleton-loader type="button"/>
              <v-skeleton-loader type="button"/>
            </div>
            <div class="statistics" v-else>
              <div class="statistic" v-for="statistic in brokerStatistics" :key="statistic.key">
                <div>{{ statistic.heading }}</div>
                <!-- @vue-skip -->
                <h3>{{ statistic.value ?? '--' }}</h3>
              </div>
            </div>
          </div>
          <div class="block personal-book-of-business">
            <h2>Personal Book of Business</h2>
            <div>Alter, lotus danistas inciviliter visum de castus, varius capio.</div>
          </div>
          <div class="block premium-by-month">
            <h2>Premium by Month</h2>
            <div>Alter, lotus danistas inciviliter visum de castus, varius capio.</div>
          </div>
          <div class="block expiration-summary">
            <h2>Expiration Summary</h2>
            <div>Alter, lotus danistas inciviliter visum de castus, varius capio.</div>
          </div>
        </div>
        <div class="stack">
          <div class="block cacs-kpis">
            <h2>Company Statistics</h2>
            <div>Alter, lotus danistas inciviliter visum de castus, varius capio.</div>
          </div>
          <div class="block book-of-business">
            <h2>Book of Business</h2>
            <div>Alter, lotus danistas inciviliter visum de castus, varius capio.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { compactMoney } from '@/utilities/Money';
import { PersonalKPI } from '@/types/Personal';
import { compactNumber } from '@/utilities/Number';
import { personalService } from '@/services/api';

export default {
  name: 'BrokerDashboard',
  data: () => ({
    loadingBrokerStatistics: true,
    kpi: {} as PersonalKPI
  }),
  computed: {
    brokerStatistics() {
      return [
        { key: 'clients', value: compactNumber(this.kpi.clients), heading: 'Favorite Clients' },
        { key: 'prospects', value: compactNumber(this.kpi.prospects), heading: 'Favorite Prospects' },
        { key: 'policies', value: compactNumber(this.kpi.policies), heading: 'Total Policies' },
        { key: 'premium', value: compactMoney(this.kpi.premium), heading: 'Total Premium' },
        { key: 'commission', value: compactMoney(this.kpi.commission), heading: 'Total Commission' },
      ];
    }
  },
  methods: {
    async refresh(): Promise<void> {
      this.loadingBrokerStatistics = true;
      this.kpi = await personalService.kpi();
      this.loadingBrokerStatistics = false;
    }
  },
  created(): Promise<void> {
    return this.refresh();
  },
};
</script>

<style scoped>
.outer {
  background: var(--v-offwhite-base);
  min-height: calc(100vh - 64px - 56px);
}

.stacks {
  display: grid;
  grid-template-columns: 20% 50% 1fr;
  grid-template-areas: "one two three";
  grid-gap: 1rem;
  margin-top: 1rem;
}

.stacks > .stack:nth-child(1) {
  grid-area: one;
}

.stacks > .stack:nth-child(2) {
  grid-area: two;
}

.stacks > .stack:nth-child(3) {
  grid-area: three;
}

.stack > .block {
  background: white;
  border: 1px solid var(--v-border-darken1);
  border-radius: 4px;
  margin-bottom: 1rem;
}

.stack > .block:last-child {
  margin-bottom: 0;
}

.stack > .block > h2 {
  background: var(--v-offwhite-base);
  padding: 0.5rem 0.5rem 0.25rem 0.5rem;
  font-size: 1rem;
  border-radius: 3px 3px 0 0;
  border-bottom: 1px solid var(--v-border-base);
}

.stack > .block > div {
  padding: 1rem;
}

.news {
  height: 200px;
}

.alerts {
  height: 150px;
}

.feed {
  height: 500px
}

.personal-book-of-business {
  height: 150px;
}

.premium-by-month {
  height: 300px;
}

.expiration-summary {
  height: 400px;
}

.cacs-kpis {
  height: 120px;
}

.book-of-business {
  height: 400px;
}

.statistics {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 1rem;
  justify-content: center;
  justify-items: center;
  align-items: end;
  align-content: end;
}

.statistic > h3 {
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
}

.statistic > div {
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: 400;
  color: var(--v-gray-base);
  letter-spacing: 0.04em;
  text-align: center;
}

@media (max-width: 1200px) {
  .stacks {
    grid-template-columns: 30% 1fr;
    grid-template-areas: "one two" "one three";
  }
}

@media (max-width: 1000px) {
  .stacks {
    grid-template-columns: 1fr;
    grid-template-areas: "two" "three" "one";
  }
}
</style>
